import React from 'react';

export const ChatFlowContext = React.createContext({});
